module.exports = __webpack_public_path__ + "assets/img/scheme_icon1.e9e4bfe5.png";